import { getRuntimeReferrer } from "./runtimeOverrides"

let gaClientId = "";

const getApiBaseUrl = () => {
	const apiUrl = process.env.REACT_APP_API_URL ?? ""

	// Use local proxy during development to avoid browser CORS restrictions.
	if (process.env.NODE_ENV === "development" && apiUrl.startsWith("http")) {
		return "/api"
	}

	return apiUrl
}

const buildApiUrl = (path: string) => `${getApiBaseUrl()}${path}`

const shouldUseProdAnalyticsSlug = (referrer: string) => {
	return referrer.toLowerCase().includes("vertaaensin")
}

export const doInitialQuery = async (data: any, isProd: boolean, referrer: string) => {
	const slug = isProd ? process.env.REACT_APP_PROD_SLUG : process.env.REACT_APP_UAT_SLUG

	const query = await fetch(buildApiUrl(`/${slug}/initiate`),
		{
			body: JSON.stringify(data),
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				"Authorization": referrer
			},
		})

	try {
		let result = await query.json();
		gaClientId = result.gaClientId;
		return result;
	} catch ( error: any ) {
		return {
			code: 400,
			message: error
		}
	}
}

export const doQuotesQuery = async (token: string, isProd: boolean, referrer: string): Promise<any> => {
	const slug = isProd ? process.env.REACT_APP_PROD_SLUG : process.env.REACT_APP_UAT_SLUG

	try {
		const query = await fetch(buildApiUrl(`/${slug}/quotes`),
			{
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"Authorization": token
				}
			})

		const response = await query

		return response
	} catch ( error: any ) {
		console.log("Error in doQuotesQuery: ", error)

		return {
			code: 400,
			message: error
		}
	}
}

export const doMatrixQuery = async (token: string, isProd: boolean, quoteId: number, matrixId: number): Promise<any> => {
	const slug = isProd ? process.env.REACT_APP_PROD_SLUG : process.env.REACT_APP_UAT_SLUG

	try {
		const query = await fetch(buildApiUrl(`/${slug}/quote/purchase/${quoteId}/${matrixId}`),
			{
				method: "PUT",
				headers: {
					"Content-Type": "application/json",
					"Authorization": token
				}
			})

		const response = await query

		return response
	} catch ( error: any ) {
		console.log("Error in doMatrixQuery: ", error)

		return {
			code: 400,
			message: error
		}
	}
}

export const sendEvent = async (token: string = "", isProd: boolean, data: any): Promise<any> => {
	const referrer = getRuntimeReferrer()
	const useProdSlug = isProd || shouldUseProdAnalyticsSlug(referrer)
	const slug = useProdSlug ? process.env.REACT_APP_PROD_SLUG : process.env.REACT_APP_UAT_SLUG

	const currentTimestamp = new Date().toISOString()
	const testEventData = {
		category: 'testing',
		action: 'initialLoad',
		label: "Testing initial load at " + currentTimestamp,
		gaClientId: "testingGaClientId" + currentTimestamp,
		referrer: referrer
	}

	data.referrer = referrer;	// We need to know which website that we are being called from
	data.gaClientId = gaClientId;

	try {
		const query = await fetch(buildApiUrl(`/${slug}/ga`),
			{
				body: JSON.stringify(data ?? testEventData),
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					"Authorization": token
				}
			})

		return await query
	} catch ( error: any ) {
		console.log("Error in sendEvent: ", error)

		return {
			code: 400,
			message: error
		}
	}
}
